import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject, observer } from 'mobx-react';

@inject('userStore')
@observer
class Artists extends Component {
    constructor(props){
        super(props);
        this.state = {
        }
    }

    render() {
        const {artist_list} = this.props;
        return (
          <div className="card card-outline-secondary">
              <div className="card-body">
                  <div className="flexbox align-items-baseline mb-20">
                      <h6 className="text-uppercase ls-2"><i className="fa fa-users"></i> Artists</h6>
                  </div>
                  <div className="gap-items-2 gap-y">
                  {artist_list.length > 0 ?
                      artist_list.map((artist, index) =>
                        <a className={artist.is_trial_user ? "avatar status-info" : "avatar"} title={artist.bus_user.full_name} key={index}><img src={artist.bus_user.avatar} alt={artist.bus_user.full_name}/></a>
                      )
                  : <span className="badge badge-info">Artists have not been assigned yet</span>}
                  </div>
              </div>
          </div>
        );
    }
}

export default Artists;



// WEBPACK FOOTER //
// ./src/components/client/Artists.js